<template>
  <div class="container">
    <div class="main">
      <div class="title">
        <img src="../../assets/mana/txt.png" alt="" />
      </div>
      <ul class="message">
        <li class="li">
          <div class="flg"></div>
          <div>各商用车经销商：</div>
        </li>
        <li>
          商用车经销商是我国商用车行业的核心资源，商用车经销商经理人是反应商用车市场最直接、最有效的市场主体。为快速、动态了解全国商用车市场运营情况，经研究，我会将开展以商用车经销商为对象的运营情况分析工作，通过经销商提报的月度销量及库存情况的分析，对商用车市场走势作出预判，辅助各企业进行优化决策，推进我国商用车行业可持续健康发展。请各商用车经销商安排人员准时提报相关信息。
        </li>
      </ul>
      <div class="info">
        <div class="user">
          <div><span style="color: #ee3024">*</span>1.经销商名称</div>
          <div v-if="userTip">必填项不能为空</div>
        </div>
        <input
          type="text"
          placeholder="请输入经销商名称"
          v-model.trim="params.name"
          maxlength="50"
        />
        <div class="user user1">
          <div><span style="color: #ee3024">*</span>2.数据月份</div>
        </div>
        <div class="month" @click="show = true">
          <div>{{ date }}</div>
          <van-icon color="#333333" name="arrow-down" size="20px" />
        </div>
        <div class="user users user1">
          <div><span style="color: #ee3024">*</span>3.主营车型【单选】</div>
          <div v-if="typeTip">必填项不能为空</div>
        </div>
        <van-radio-group v-model="type">
          <van-radio icon-size="12px" name="1" shape="square">重卡</van-radio>
          <van-radio icon-size="12px" name="2" shape="square">中卡</van-radio>
          <van-radio icon-size="12px" name="3" shape="square">轻卡</van-radio>
          <van-radio icon-size="12px" name="4" shape="square">轻客</van-radio>
        </van-radio-group>

        <div class="user user1">
          <div><span style="color: #ee3024">*</span>4.当月销量（辆）</div>
          <div v-if="salesTip">必填项不能为空</div>
        </div>
        <input
          type="number"
          placeholder="请输入当月销量"
          v-model.trim="params.sales"
          @input="salesChange"
          @blur="salesChange"
          maxlength="6"
        />
        <div class="user user1">
          <div><span style="color: #ee3024">*</span>5.当月库存量（辆）</div>
          <div v-if="stockTip">必填项不能为空</div>
        </div>
        <input
          type="number"
          placeholder="请输入库存量"
          v-model.trim="params.inventory"
          @input="stockChange"
          maxlength="6"
        />
      </div>
      <div class="box">
        <div class="bl">
          <div>具体要求如下</div>
        </div>
        <div>
          一、填报：每月1至5日填报上月运营信息，主要为上月销量和库存量。
        </div>
        <div>
          二、发布：每月10日前以“商用车经理人指数”名义对外发布全国商用车经销商运营情况。
        </div>
        <div>三、数据提报请扫描二维码</div>
        <div class="blf">
          <div>联系人：</div>
          <div>郑老师：18511753874（微信同号）</div>
        </div>
        <div class="blf">
          <div></div>
          <div>朱老师：15910751162（微信同号）</div>
        </div>
        <div>邮箱：ccvda@cada.cn/2437081380@qq.com</div>
        <div class="logos">
          <img
            src="https://vehicle-library.oss-cn-beijing.aliyuncs.com/cvbd-icon/manager_index_5.jpg"
            alt=""
          />
        </div>
      </div>
      <div class="logo">
        <img src="../../assets/logma.png" alt="" />
      </div>
    </div>
    <div class="btnbox">
      <div class="btn" @click="submit">提交</div>
    </div>
    <van-popup v-model="show" position="bottom" :style="{ height: '40%' }">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @confirm="confirm"
        @cancel="show = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { mgrIndex, getCompany } from "@/utils/http.js";
import moment from "moment";
import { Toast } from "vant";
export default {
  data() {
    return {
      params: {
        name: "",
        date: "",
        vehicleType: "",
        sales: "",
        inventory: "",
      },
      type: "1",
      minDate: new Date(2009, 12),
      maxDate: new Date(),
      currentDate: new Date(),
      userTip: false,
      salesTip: false,
      stockTip: false,
      typeTip: false,
      show: false,
      date: "",
    };
  },
  created() {
    sessionStorage.setItem("token", this.$route.query.token);
    const lastMonthDate = moment().subtract(1, "month");
    let month = lastMonthDate.format("MM").replace(/^0+/, "");
    this.date = `${lastMonthDate.format("YYYY")}年${month}月`;
    this.currentDate = new Date(lastMonthDate.format("YYYY"), month - 1);
    getCompany({}).then((res) => {
      //console.log(res);
      if (res.data.resultStates != 0) {
        return;
      }
      this.params.name = res.data.content;
    });
  },
  mouted() {},
  methods: {
    salesChange(e) {
      this.$set(this.params, "sales", e.target.value.replace(/[^0-9]/g, ""));
    },
    stockChange(e) {
      this.$set(this.params, "inventory", e.target.value.replace(/[^0-9]/g, ""));
    },
    formatMonth(dateStr) {
      return dateStr.replace(
        /(\d{4})年(\d)(?!\d)/g, // 只匹配个位数月份
        (match, year, month) => `${year}年${month.padStart(2, "0")}`
      );
    },

    async submit() {
      if (this.type == 1) {
        this.params.vehicleType = "重卡";
      }
      if (this.type == 2) {
        this.params.vehicleType = "中卡";
      }
      if (this.type == 3) {
        this.params.vehicleType = "轻卡";
      }
      if (this.type == 4) {
        this.params.vehicleType = "轻客";
      }
      if (!this.params.name) {
        this.userTip = true;
        Toast("经销商名称不能为空");
        return;
      }
      this.userTip = false;
      if (!this.params.vehicleType) {
        this.typeTip = true;
        Toast("主营车型不能为空");
        return;
      }
      this.typeTip = false;
      if (!this.params.sales) {
        this.salesTip = true;
        Toast("当月销量不能为空");
        return;
      }
      this.salesTip = false;
      if (!this.params.inventory) {
        this.stockTip = true;
        Toast("当月库存量不能为空");
        return;
      }
      this.params.date = await this.formatMonth(this.date);
      this.stockTip = false;
      mgrIndex(this.params).then((res) => {
        if (res.data.resultStates != 0) {
          //console.log(res.data.failureReason);
          if (res.data.failureReason == 3) {
            Toast("您已提交过该月份的数据，请勿重复提交");
          }
          if (res.data.failureReason == 2) {
            Toast("数据月份不正确，请重新选择");
          }
          if (res.data.failureReason == 1) {
            Toast("数据格式不正确，请重新填写");
          }
          if (res.data.failureReason == 101) {
            Toast("登陆已过期，请重新登陆");
          }
        } else {
          this.$router.replace("/success");
        }
      });
    },
    formatter(type, value) {
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      }
      return value;
    },
    confirm(value) {
      let month = value.getMonth() + 1;
      // if (month < 10) {
      //   month = `0${month}`;
      // }
      this.date = `${value.getFullYear()}年${month}月`;
      this.show = false;
    },
  },
};
</script>
<style scoped>
.container {
  /* height: 100vh; */
  background: url("../../assets/mana/bg.jpg") no-repeat;
}
.main {
  width: 375px;
  /* height: 732px; */
  /* height: 668px; */
  /* height: 100vh; */
  /* background: url("../../assets/mana/bg.jpg") no-repeat; */
  background-size: 100% 100%;
  box-sizing: border-box;
  padding: 40px 15px;
  padding-bottom: 75px;
}

.title {
  font-family: ZhenyanGB, ZhenyanGB;
  font-weight: 600;
  font-size: 24px;
  color: #ffffff;
  text-align: center;
}
.title > img {
  width: 310px;
  height: 23px;
}
.message {
  width: 345px;
  /* height: 126px; */
  background: #ffffff;
  border-radius: 10px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 12px;
  color: #363636;
  box-sizing: border-box;
  padding: 10px 15px;
  margin-top: 30px;
}
.message > li:nth-of-type(2) {
  text-indent: 24px;
  line-height: 18px;
  margin-top: 4px;
}
.li {
  display: flex;
  align-items: center;
}
.flg {
  width: 1px;
  height: 11px;
  background: #051e77;
  border: 1px solid #051e77;
  margin-right: 3px;
}
.info {
  width: 345px;
  /* height: 327px; */
  background: #ffffff;
  border-radius: 10px;
  margin-top: 20px;
  box-sizing: border-box;
  padding: 15px;
  padding-bottom: 20px;
}
.user {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 4px;
}
.user > div:nth-of-type(2) {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 12px;
  color: #ee3024;
}
input {
  width: 315px;
  height: 26px;
  border-radius: 2px;
  border: 1px solid #999999;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  text-indent: 6px;
  /* color: #333333; */
}
.van-radio-group {
  display: flex;
}
>>> .van-radio__label {
  font-family: PingFang-SC, PingFang-SC;
  font-weight: 500;
  font-size: 13px;
  color: #333333;
  margin-left: 4px;
}
.van-radio {
  margin-right: 10px;
}
.users {
  /* margin-bottom: 6px; */
}
.month {
  width: 315px;
  height: 26px;
  border-radius: 2px;
  border: 1px solid #999999;
  display: flex;
  align-items: center;
  font-family: PingFang-SC, PingFang-SC;
  font-weight: 500;
  font-size: 13px;
  color: #333333;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 6px;
  /* margin-top: 8px; */
}
.btnbox {
  width: 375px;
  background: #ffffff;
  height: 75px;
  /* box-shadow: 0px 0px 3px 0px #e2e2e2; */
  position: fixed;
  bottom: 0;
  box-sizing: border-box;
  padding: 10px 0;
}
.btn {
  width: 270px;
  line-height: 45px;
  /* background: linear-gradient(#02007e 0%, #4981e0 100%); */
  background: linear-gradient(#4981e0 0%, #02007e 100%);
  box-shadow: 0px 1px 4px 0px #79b4ff;
  border-radius: 5px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 15px;
  color: #ffffff;
  text-align: center;
  margin: 0 auto;
}
.user1 {
  /* margin-bottom: 20px; */
  margin-top: 15px;
}
.logo {
  text-align: center;
  margin-top: 8px;
}
.logo > img {
  width: 195px;
  height: 32px;
}
.box {
  width: 345px;
  /* height: 252rpx; */
  background: #ffffff;
  border-radius: 10px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 12px;
  color: #363636;
  box-sizing: border-box;
  padding: 10px 15px;
  margin-top: 10px;
  position: relative;
}
.blf {
  display: flex;
}

.blf > div:nth-of-type(1) {
  width: 49px;
}

.bl {
  font-size: 12px;
  margin-bottom: 4px !important;
}
.logos {
  position: absolute;
  bottom: 20px;
  right: 22px;
}

.logos img {
  width: 54px;
  height: 54px;
}
.box div {
  margin-top: 2px;
  line-height: 18px;
}
</style>